
const pathConstants = {
  KYC: "/csi/government/kyc",
  CRC: "/csi/government/crc",
  NATURE: "/csi/government/nature",
  AQI: "/csi/government/nature/aqi",
  LiveAQI: "/csi/government/nature/liveaqi",
  CompareAQI: "/csi/government/nature/compareAqi",
  AqiNew: "/csi/government/nature/aqi_new",
  TEMP: "/csi/government/nature/temp",
  RAIN: "/csi/government/nature/rain",
  LAND: "/csi/government/nature/land",
  WATER: "/csi/government/nature/water",
  WASTE: "/csi/government/nature/waste",
  SOCIETY: "/csi/government/society",
  HEALTHCARE: "/csi/government/society/healthcare",
  EMPLOYMENT: "/csi/government/society/employment",
  EDUCATION: "/csi/government/society/education",
  TRANSPORT: "/csi/government/society/transport",
  COMMUNITY: "/csi/government/society/community",
  CULTURE: "/csi/government/society/culture",
  ADMIN: "/csi/government/admin",
  DISASTER: "/csi/government/admin/disaster",
};

export default pathConstants;
